import { ContentBarContainer } from './styled';
export function ContentBar(props) {
    const { children } = props;
    return <ContentBarContainer>{children}</ContentBarContainer>;
}
